import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sIcon.png'
import _imports_1 from '@/assets/uIcon.png'
import _imports_2 from '@/assets/float.png'


const _withScopeId = n => (_pushScopeId("data-v-cf1fbbd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-departmentid", "data-businessday"]
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "float-end" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Care Assignment Sheet", -1))
const _hoisted_10 = { class: "table table-bordered careAssignmentsheet-summary care-assignment-print" }
const _hoisted_11 = {
  colspan: "4",
  scope: "row",
  class: ""
}
const _hoisted_12 = {
  colspan: "4",
  scope: "row",
  class: ""
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  scope: "row",
  class: "font-weight-bold"
}, "Date", -1))
const _hoisted_14 = {
  scope: "row",
  class: ""
}
const _hoisted_15 = {
  scope: "row",
  class: "font-weight-bold"
}
const _hoisted_16 = {
  scope: "row",
  class: "font-weight-bold"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  scope: "row",
  class: ""
}, " Part of Day ", -1))
const _hoisted_18 = {
  colspan: "2",
  scope: "row",
  class: ""
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "care-assignment-sheet-grid" }
const _hoisted_23 = {
  color: "plain-0",
  class: "p-0 m-0"
}
const _hoisted_24 = { class: "neutable care-assignment-print" }
const _hoisted_25 = ["columns"]
const _hoisted_26 = { align: "left" }
const _hoisted_27 = ["columns", "slot"]
const _hoisted_28 = ["title"]
const _hoisted_29 = ["title"]
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "associaionIcon",
  title: "Secondary Association"
}, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { key: 2 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "associaionIcon",
  title: "Unassociated"
}, null, -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { key: 3 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"16px","float":"right"},
  src: _imports_2,
  alt: "Float"
}, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["title"]
const _hoisted_41 = ["title"]
const _hoisted_42 = ["title"]
const _hoisted_43 = ["title"]
const _hoisted_44 = ["title"]
const _hoisted_45 = ["title"]
const _hoisted_46 = ["title"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_49 = { class: "notes-col" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PlusMetricsReport = _resolveComponent("PlusMetricsReport")!
  const _component_ClockInsReport = _resolveComponent("ClockInsReport")!
  const _component_EditAssignment = _resolveComponent("EditAssignment")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.careAssignmentSheetReportInput, (data, index) => {
      return (_openBlock(), _createElementBlock("div", { key: data }, [
        _createElementVNode("div", {
          class: "dailyRosterDetail-card p-2 mb-2",
          style: {"background-color":"white"},
          "data-departmentid": data.departmentId,
          "data-businessday": _ctx.GetBusinessDay(data.businessDay)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(['heading ', index != 0 ? 'dailyRoasterPrintPageBreak': ''])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h5", null, _toDisplayString('(' + data.facilityCoId + ') ' + data.facilityName), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h5", _hoisted_5, _toDisplayString('(' + data.departmentCode + ') ' + data.departmentName), 1)
              ])
            ])
          ], 2),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("table", _hoisted_10, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_11, _toDisplayString('(' + data.facilityCoId + ') ' + data.facilityName), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString('(' + data.departmentCode + ') ' + data.departmentName), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_13,
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.GetSummarySectionDate(data.businessDay)), 1),
                    _createElementVNode("td", _hoisted_15, "Total Scheduled : " + _toDisplayString(_ctx.GetTotalSchedule(data.skills)), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.GetSkillText(data.skills)), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_17,
                    _createElementVNode("td", _hoisted_18, _toDisplayString(data.partOfDay), 1)
                  ])
                ])
              ])
            ]),
            _hoisted_19
          ]),
          (data.assignments != null && data.assignments.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("table", _hoisted_24, [
                        _createElementVNode("colgroup", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                            return (_openBlock(), _createElementBlock("col", {
                              key: column,
                              style: _normalizeStyle({'width': _ctx.columnHeaders[column] })
                            }, null, 4))
                          }), 128))
                        ]),
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", {
                            columns: _ctx.columnHeaders,
                            header: ""
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                              return (_openBlock(), _createElementBlock("th", { key: column }, _toDisplayString(column), 1))
                            }), 128))
                          ], 8, _hoisted_25)
                        ]),
                        _createElementVNode("tbody", _hoisted_26, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.assignments, (dataItem) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              columns: _ctx.columnHeaders,
                              slot: _ctx.column,
                              key: dataItem,
                              class: _normalizeClass(_ctx.getAssignmentClassForRow(dataItem))
                            }, [
                              _createElementVNode("td", {
                                title: dataItem.departmentCode,
                                class: "department-col"
                              }, _toDisplayString(dataItem.departmentCode), 9, _hoisted_28),
                              _createElementVNode("td", {
                                title: dataItem.lastAndFirstName,
                                class: _normalizeClass([(dataItem.departmentId !== data.departmentId ) ? 'strikethrough employee-col' : 'employee-col'])
                              }, [
                                _createTextVNode(_toDisplayString(dataItem.lastAndFirstName) + " ", 1),
                                (dataItem.charge)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: ['fa', 'user-md'],
                                        size: "sm",
                                        style: {"float":"right","font-size":"16px"}
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                (dataItem.associationType === _ctx.defaults.secondaryStaff)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, _hoisted_33))
                                  : _createCommentVNode("", true),
                                (dataItem.associationType === _ctx.defaults.unassociatedStaff)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, _hoisted_36))
                                  : _createCommentVNode("", true),
                                (dataItem.float)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, _hoisted_39))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_29),
                              _createElementVNode("td", {
                                title: dataItem.credentialsExpiration
                              }, _toDisplayString(dataItem.credentialsExpiration), 9, _hoisted_40),
                              _createElementVNode("td", {
                                title: dataItem.skillLevelDescription,
                                class: _normalizeClass([(dataItem.departmentId !== data.departmentId ) ? 'strikethrough' : ''])
                              }, _toDisplayString(dataItem.skillLevelDescription), 11, _hoisted_41),
                              _createElementVNode("td", {
                                title: dataItem.employeeType
                              }, _toDisplayString(dataItem.employeeType), 9, _hoisted_42),
                              _createElementVNode("td", {
                                title: dataItem.hours,
                                class: _normalizeClass([(dataItem.overtimeShift) ? 'overtime': ''])
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass([(dataItem.departmentId !== data.departmentId ) ? 'strikethrough' : ''])
                                }, _toDisplayString(dataItem.hours), 3)
                              ], 10, _hoisted_43),
                              _createElementVNode("td", {
                                title: dataItem.shiftCode,
                                class: _normalizeClass([(dataItem.overtimeShift && !dataItem.cancel) ? 'shift-col overtime': 'shift-col'])
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass([(dataItem.departmentId !== data.departmentId ) ? 'strikethrough' : ''])
                                }, _toDisplayString(dataItem.shiftCode), 3)
                              ], 10, _hoisted_44),
                              _createElementVNode("td", {
                                title: _ctx.AssignmentStartTime(dataItem.startTime),
                                class: _normalizeClass([(dataItem.departmentId !== data.departmentId ) ? 'strikethrough' : ''])
                              }, _toDisplayString(_ctx.AssignmentStartTime(dataItem.startTime)), 11, _hoisted_45),
                              _createElementVNode("td", {
                                title: _ctx.AssignmentEndTime(dataItem.endTime),
                                class: _normalizeClass([(dataItem.departmentId !== data.departmentId ) ? 'strikethrough' : ''])
                              }, _toDisplayString(_ctx.AssignmentEndTime(dataItem.endTime)), 11, _hoisted_46),
                              _hoisted_47,
                              _hoisted_48,
                              _createElementVNode("td", _hoisted_49, [
                                (dataItem.hasNotes)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: ['fa', 'sticky-note'],
                                        size: "sm",
                                        onClick: ($event: any) => (_ctx.onEditingShift(dataItem))
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ], 10, _hoisted_27))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_51,
          (data.plusMetrics != null)
            ? (_openBlock(), _createBlock(_component_PlusMetricsReport, {
                key: 1,
                plusMetricsReportInput: data.plusMetrics,
                facilityName: data.facilityName,
                departmentName: data.departmentName
              }, null, 8, ["plusMetricsReportInput", "facilityName", "departmentName"]))
            : _createCommentVNode("", true),
          (data.clockIns != null && data.clockIns.shiftClockIns != null && data.clockIns.shiftClockIns.length > 0)
            ? (_openBlock(), _createBlock(_component_ClockInsReport, {
                key: 2,
                clockInsInput: data.clockIns
              }, null, 8, ["clockInsInput"]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1)
      ]))
    }), 128)),
    (_ctx.isEditAssignment)
      ? (_openBlock(), _createBlock(_component_EditAssignment, {
          key: 0,
          assignmentInput: _ctx.assignmentInput,
          assignmentType: _ctx.assignmentType,
          onCloseModal: _ctx.closeEditAssignment
        }, null, 8, ["assignmentInput", "assignmentType", "onCloseModal"]))
      : _createCommentVNode("", true)
  ], 64))
}